import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { SupplierApprovedVendorListPatchDTORuntype, SupplierAvlScopesDTORuntype } from './avlScopeBackendTypes';

export const avlScopeEndpoints = {
    'GET /approved-vendor-lists': endpoint({
        description: 'Returns the scope-based approved vendor lists for all suppliers',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(SupplierAvlScopesDTORuntype),
    }),

    'GET /approved-vendor-lists/suppliers/:supplierId': endpoint({
        description: 'Returns the scope-based approved vendor list for a supplier',
        pathParams: z.object({ supplierId: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: SupplierAvlScopesDTORuntype,
    }),

    'PATCH /approved-vendor-lists/suppliers/:supplierId': endpoint({
        description: 'Sets the scope-based approved vendor list for a supplier',
        pathParams: z.object({ supplierId: z.string() }),
        queryParams: z.undefined(),
        requestBody: SupplierApprovedVendorListPatchDTORuntype,
        responseBody: SupplierAvlScopesDTORuntype,
        invalidates: ['GET /approved-vendor-lists/suppliers/:supplierId', 'GET /approved-vendor-lists'],
    }),

    'DELETE /approved-vendor-lists/:ruleId': endpoint({
        description: 'Removes a single rule from the scope-based approved vendor list',
        pathParams: z.object({ ruleId: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.null(),
        invalidates: ['GET /approved-vendor-lists/suppliers/:supplierId', 'GET /approved-vendor-lists'],
    }),
};
